var map = {
	"./activist.png": 100,
	"./blue.png": 6686,
	"./bluegrey.png": 8062,
	"./blueyellow.png": 6216,
	"./convo_blue.png": 747,
	"./convo_bluegrey.png": 4973,
	"./convo_grey.png": 8303,
	"./democratic-discussion.png": 5839,
	"./discussion.png": 650,
	"./fair_blue.png": 5600,
	"./fair_bluegrey.png": 4329,
	"./fair_blueyellow.png": 3356,
	"./fair_grey.png": 1145,
	"./fair_greyyellow.png": 1974,
	"./fair_yellow.png": 7787,
	"./fossil-free.png": 3629,
	"./fossil-ties.png": 7397,
	"./grey.png": 7094,
	"./greyyellow.png": 2408,
	"./intransparent.png": 902,
	"./money_blue.png": 3539,
	"./money_bluegrey.png": 2029,
	"./money_blueyellow.png": 8145,
	"./money_grey.png": 3851,
	"./money_greyyellow.png": 6136,
	"./news.png": 8736,
	"./no-discussion.png": 19,
	"./no-fossil-policy.png": 6518,
	"./no-no-fossil-policy.png": 6303,
	"./no-sustainability-policy.png": 286,
	"./policy_blue.png": 8254,
	"./policy_bluegrey.png": 7395,
	"./policy_blueyellow.png": 2986,
	"./policy_grey.png": 9259,
	"./policy_greyyellow.png": 3683,
	"./prof_blue.png": 3018,
	"./prof_bluegrey.png": 3776,
	"./prof_blueyellow.png": 4538,
	"./prof_grey.png": 4787,
	"./prof_greyyellow.png": 9604,
	"./progress.png": 134,
	"./sustainability-policy.png": 4401,
	"./transparent.png": 3884,
	"./unknown-fossil.png": 2077,
	"./unknown-transparent.png": 4791,
	"./unknown.png": 7440,
	"./yellow.png": 9153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;